/*
 * XNGAGE CONFIDENTIAL
 * __________________________
 *
 * Copyright (C) 2024 Xngage - All Rights Reserved
 *
 * All code or information contained herein is, and remains the
 * property of Xngage LLC and its customers. The intellectual
 * and technical concepts contained are proprietary to Xngage LLC
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Xngage LLC.
 */

import { pdfLinkCellStyles } from "@eisinc/App/Components/PaymentCenter/PDFLinkCell";
import { css } from "styled-components";

pdfLinkCellStyles.modalPDFWrapper = {
    css: css`
        margin-bottom: 10px;
    `,
};

pdfLinkCellStyles.spinner = {
    color: "primary.main",
    size: 30,
};

pdfLinkCellStyles.invoiceItemNumberDataCellLink = {
    css: css`
        min-width: 80px;
    `,
};

pdfLinkCellStyles.invoiceItemNumberNonCredit = {
    variant: "p",
    size: 14,
    lineHeight: "17px",
    css: css`
        min-width: 80px;
        margin-bottom: 0;
    `,
};
